class FillController {
  /* @ngInject */
  constructor($window, $stateParams, $http, $state, CifShareService, Session, urls) {
    this.$window = $window;
    this.$stateParams = $stateParams;
    this.$http = $http;
    this.$state = $state;
    this.CifShareService = CifShareService;
    this.Session = Session;
    this.urls = urls;
    this.caseConfigId = this.$stateParams.id;

    this.datepickerOptions = {
    };

    this.tabIndexMap = {
      basicDetails: 0,
      employmentDetails: 1,
      addressDetails: 2,
      educationDetails: 3,
      miscDetails: 4,
    };

    this.steps = [true, true, true, true];
    this.forms = [];
    this.currTabs = ['basicDetails'];
    this.ignoreAuth = this.$state.current.name === 'public.case.response';
    this.enableCifStates = [3, 5, 6, 7, 8, 16, 17];
    this.showGapDetails = true;
  }

  $onInit() {
    this.isBetaUser = (this.Session.read('debug') || {}).userType === 'beta';
    this.showSpinner = true;
    this.$http.get(`${this.ignoreAuth ? '/public' : ''}/case/${this.caseConfigId}`, {
      params: { config: true, caseResponse: true },
      ignoreAuthModule: this.ignoreAuth,
    })
      .then(({ data }) => {
        this.case = data;
        this.setUp();
        this.showSpinner = false;
      });
  }

  setUp() {
    this.caseConfig = this.case.config;
    this.identity = {
      Pan: [],
      Passport: [],
      Aadhaar: [],
      DrivingLicense: [],
    };
    this.educationAttch = [];
    this.employmentAttch = [];
    this.miscellaneousAttch = {
      Miscellaneous: [],
      Resume: [],
    };
    this.activeTab = 0;

    this.disableEdit = this.case && this.ignoreAuth
    && !this.enableCifStates.includes(this.case.CurrentState.state_id);

    if (this.case && this.case.CaseResponse) {
      const { id: caseResponseId } = this.case.CaseResponse;
      this.data = this.case.CaseResponse.response;

      if (this.data.basicDetails) {
        this.data.basicDetails = Object.assign({
          fullName: '',
          lastName: '',
          emailId: '',
          contactNumber: '',
          dob: null,
          maritalStatus: 'Married',
          gender: 'Male',
          nationality: 'Indian',
        }, this.data.basicDetails);
      }

      const addr = this.data.addressDetails;
      if (addr) {
        this.data.addressDetails = {
          permanent: addr.permanent,
          residential: addr.residential
            ? addr.residential.map(res => Object.assign({
              startDate: '',
              endDate: '',
              address: '',
            }, res))
            : null,
          employment: addr.employment
            ? addr.employment.map(emp => Object.assign({
              address: '',
            }, emp))
            : null,
        };
      }

      const gapDetails = this.data.miscDetails.gapDetails;

      if (gapDetails) {
        this.data.miscDetails.gapDetails = gapDetails.map(res => Object.assign({
          startDate: '',
          endDate: '',
          clarification: '',
        }, res));
      } else {
        this.data.miscDetails = Object.assign(this.data.miscDetails, {
          gapDetails: [],
        });
      }

      if (this.data.educationDetails) {
        this.data.educationDetails = this.data.educationDetails.map(ed => Object.assign({
          name: '',
          startDate: '',
          endDate: '',
          rollNumber: '',
          instituteDetails: '',
          universityDetails: '',
          instituteContactNumber: '',
        }, ed));
      }

      if (this.data.employmentDetails) {
        this.data.employmentDetails = this.data.employmentDetails.map(emp => Object.assign({
          name: '',
          employeeId: '',
          contactNumber: '',
          jobTitle: '',
          dateOfJoining: null,
          dateOfLeaving: null,
          grossSalary: '',
          reasonForLeaving: '',
          supervisorName: '',
          supervisorContactNumber: '',
          hrName: '',
          hrContactNumber: '',
        }, emp));
      }

      this.attachments = (this.case.CaseResponse.CaseResponseAttachments || [])
        .reduce((acc, a) => Object.assign(acc, { [a.id]: a }), {});

      this.data.employmentDetails.map((e, index) => {
        const attachments = (e.attachmentIds || []).map(i => ({
          id: i,
          filename: this.attachments[i].path.split('/').pop(),
          case_response_id: caseResponseId,
        }));

        Object.assign(e, { attachments });
        this.employmentAttch[index] = attachments;

        return e;
      });

      this.data.educationDetails.map((e, index) => {
        const attachments = (e.attachmentIds || []).map(i => ({
          id: i,
          filename: this.attachments[i].path.split('/').pop(),
          case_response_id: caseResponseId,
        }));

        Object.assign(e, { attachments });
        this.educationAttch[index] = attachments;

        return e;
      });

      Object.keys(this.identity).map(k => (
        this.case.CaseResponse.CaseResponseAttachments.map(a => {
          if (a.type === k) {
            this.identity[k].push({
              type: k,
              id: a.id,
              filename: a.path.split('/').pop(),
              case_response_id: caseResponseId,
            });

            return true;
          }

          return false;
        })
      ));

      this.data.miscDetails = this.data.miscDetails || {
        uan: '',
        gapDetails: [],
        attachments: [],
        additionalInformation: '',
      };

      Object.keys(this.miscellaneousAttch).map(k => (
        this.case.CaseResponse.CaseResponseAttachments.map(a => {
          if (a.type === k) {
            this.miscellaneousAttch[k].push({
              type: k,
              id: a.id,
              filename: a.path.split('/').pop(),
              case_response_id: caseResponseId,
            });

            return true;
          }

          return false;
        })
      ));

      this.modifyBasicDetailsAttach();
      this.modifyEducationAttach();
      this.modifyEmploymentAttach();
      this.modifyMiscellaneousAttach();
    } else {
      this.data = {
        basicDetails: {
          fullName: this.case.full_name,
          lastName: this.case.last_name,
          emailId: this.case.email,
          contactNumber: '',
          dob: null,
          maritalStatus: 'Married',
          gender: 'Male',
          nationality: 'Indian',
        },
        employmentDetails: [{
          name: '',
          employeeId: '',
          contactNumber: '',
          jobTitle: '',
          dateOfJoining: null,
          dateOfLeaving: null,
          grossSalary: '',
          reasonForLeaving: '',
          supervisorName: '',
          supervisorContactNumber: '',
          hrName: '',
          hrContactNumber: '',
        }],
        addressDetails: {
          permanent: '',
          residential: [{
            address: '',
            startDate: '',
            endDate: '',
          }],
          employment: [{ address: '' }],
        },
        educationDetails: [{
          name: '',
          startDate: '',
          endDate: '',
          rollNumber: '',
          instituteDetails: '',
          universityDetails: '',
          instituteContactNumber: '',
        }],
        miscDetails: {
          uan: '',
          gapDetails: [],
          attachments: [],
          additionalInformation: '',
        },
      };
    }

    this.nationality = {
      getList: (q, limit = 10) => {
        const text = q.charAt(0).toUpperCase() + q.slice(1).toLowerCase();
        const appendAddNew = (list) => (list.some(l => l.toLowerCase() === q.toLowerCase())
          ? list
          : list.concat([`Add new: ${q}`]));

        const filterLimit = (list) => list.filter(l => l.includes(text)).splice(0, limit);

        if (this.nationality.list) return appendAddNew(filterLimit(this.nationality.list));

        return this.$http
          .get(`${this.urls.CDN_LINK}/typeaheads/nationality_120819.json`,
            { ignoreAuthModule: true })
          .then(({ data }) => {
            this.Session.create('nationality_120819', data);
            this.nationality.list = data;
            return appendAddNew(filterLimit(this.nationality.list));
          });
      },
      select: ($item) => {
        const name = $item.replace('Add new: ', '');
        const isNationality = this.nationality.list
          .some(l => l.toLowerCase() === name.toLowerCase());

        if (!isNationality) {
          const text = name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
          this.nationality.list.push(text);
        }

        return (this.data.basicDetails.nationality = name);
      },
      list: this.Session.read('nationality_120819'),
    };

    this.degrees = {
      getList: (q, limit = 10) => {
        const text = q.charAt(0).toUpperCase() + q.slice(1).toLowerCase();
        const appendAddNew = (list) => (list.some(l => l.toLowerCase() === q.toLowerCase())
          ? list
          : list.concat([`Add new: ${q}`]));

        const filterLimit = (list) => list.filter(l => l.includes(text)).splice(0, limit);

        if (this.degrees.list) return appendAddNew(filterLimit(this.degrees.list));

        return this.$http
          .get(`${this.urls.CDN_LINK}/typeaheads/qualifications_020118.json`,
            { ignoreAuthModule: true })
          .then(({ data }) => {
            this.Session.create('qualifications_020118', data);
            this.degrees.list = data;
            return appendAddNew(filterLimit(this.degrees.list));
          });
      },
      select: ($item, index) => {
        const name = $item.replace('Add new: ', '');
        const isDegrees = this.degrees.list
          .some(l => l.toLowerCase() === name.toLowerCase());

        if (!isDegrees) {
          const text = name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
          this.degrees.list.push(text);
        }

        return (this.data.educationDetails[index].name = name);
      },
      list: this.Session.read('qualifications_020118'),
    };

    this.Employers = {
      getList: (query = '') => {
        const q = (query || '').trim();
        return this.$http
          .get(`${this.urls.CLEARBIT_LINK}/v1/companies/suggest`, {
            ignoreAuthModule: true,
            params: { query: q },
          })
          .then(({ data }) => data
            .map(list => list.name));
      },
      select: ($item, index) => { this.data.employmentDetails[index].name = $item; },
      noResults: false,
      loadingEmployers: false,
    };

    this.setPreConditions();
  }

  setEmploymentPre() {
    const employmentCheck = this.caseConfig.employmentCheck;
    const empCheck = employmentCheck.selected;
    const empRefCheck = this.caseConfig.employmentReferenceCheck.selected;
    this.showEmploymentTab = empCheck || empRefCheck;

    if (this.showEmploymentTab) {
      this.currTabs.push('employmentDetails');

      const empCheckMaxEmp = empCheck && employmentCheck.maxEmployments;
      this.maxEmploymentYear = Math.max(
        empCheck && employmentCheck.maxYears,
        empRefCheck && this.caseConfig.employmentReferenceCheck.maxYears
      );

      this.maxEmployment = empCheckMaxEmp || 20;
      this.employmentLabel = `${
        this.maxEmploymentYear ? `Last ${this.maxEmploymentYear} year(s)` : ''
      }${(this.maxEmploymentYear && empCheckMaxEmp) ? ' - ' : ''}${
        empCheckMaxEmp ? `Upto ${empCheckMaxEmp} employment(s)` : ''}`;
    }
  }

  setAddressPre() {
    const criminalPoliceCheck = this.caseConfig.criminalPoliceCheck;
    const criminalCourtRecordCheck = this.caseConfig.criminalCourtRecordCheck;
    const eCourtRecordCheck = this.caseConfig.eCourtRecordCheck;
    const addressCheck = this.caseConfig.addressCheck;
    const digitalAddressCheck = this.caseConfig.digitalAddressCheck;
    const creditScoreCheck = this.caseConfig.creditScoreCheck;

    const criminalPoliceCheckEnabled = criminalPoliceCheck.selected;
    const criminalCourtRecordCheckEnabled = criminalCourtRecordCheck.selected;
    const eCourtRecordCheckEnabled = eCourtRecordCheck.selected;
    const addressCheckEnabled = addressCheck.selected;
    const digitalAddressCheckEnabled = digitalAddressCheck.selected;

    this.showAddrTab = criminalPoliceCheckEnabled
      || addressCheckEnabled
      || digitalAddressCheckEnabled
      || criminalCourtRecordCheckEnabled
      || eCourtRecordCheckEnabled
      || creditScoreCheck.selected;

    if (this.showAddrTab) {
      this.currTabs.push('addressDetails');
      this.showResAddr =
        addressCheck.isResidentialAddressCheck ||
        digitalAddressCheck.isResidentialAddressCheck ||
        criminalPoliceCheck.isResidentialAddressCheck.selected ||
        criminalCourtRecordCheck.isResidentialAddressCheck.selected ||
        eCourtRecordCheck.isResidentialAddressCheck.selected ||
        (
          creditScoreCheck.selected
          && creditScoreCheck.isResidentialAddressCheck.selected
        );

      this.showPermAddr =
        addressCheck.isPermanentAddressCheck ||
        digitalAddressCheck.isPermanentAddressCheck ||
        criminalPoliceCheck.isPermanentAddressCheck ||
        criminalCourtRecordCheck.isPermanentAddressCheck ||
        eCourtRecordCheck.isPermanentAddressCheck;

      this.showEmpAddr =
        (
          criminalPoliceCheckEnabled &&
          criminalPoliceCheck.isEmploymentAddressCheck.selected
        )
        || (
          criminalCourtRecordCheckEnabled &&
          criminalCourtRecordCheck.isEmploymentAddressCheck &&
          criminalCourtRecordCheck.isEmploymentAddressCheck.selected
        )
        || (
          eCourtRecordCheckEnabled &&
          eCourtRecordCheck.isEmploymentAddressCheck &&
          eCourtRecordCheck.isEmploymentAddressCheck.selected
        );

      if (this.showEmpAddr) {
        this.empAddrYears = Math.max(
          (
            criminalPoliceCheckEnabled
            && criminalPoliceCheck.isEmploymentAddressCheck
            && criminalPoliceCheck.isEmploymentAddressCheck.selected
            && criminalPoliceCheck.isEmploymentAddressCheck.maxYears
          ),
          (
            criminalCourtRecordCheckEnabled
            && criminalCourtRecordCheck.isEmploymentAddressCheck
            && criminalCourtRecordCheck.isEmploymentAddressCheck.selected
            && criminalCourtRecordCheck.isEmploymentAddressCheck.maxYears
          ),
          (
            eCourtRecordCheckEnabled
            && eCourtRecordCheck.isEmploymentAddressCheck
            && eCourtRecordCheck.isEmploymentAddressCheck.selected
            && eCourtRecordCheck.isEmploymentAddressCheck.maxYears
          )
        );
      }

      this.showAddressRange = criminalCourtRecordCheckEnabled || eCourtRecordCheckEnabled;

      if (this.showResAddr) {
        this.resAddrYears = Math.max(
          (
            criminalPoliceCheckEnabled
            && criminalPoliceCheck.isResidentialAddressCheck
            && criminalPoliceCheck.isResidentialAddressCheck.maxYears
          ),
          (
            criminalCourtRecordCheckEnabled
            && criminalCourtRecordCheck.isResidentialAddressCheck
            && criminalCourtRecordCheck.isResidentialAddressCheck.maxYears
          ),
          (
            eCourtRecordCheckEnabled
            && eCourtRecordCheck.isResidentialAddressCheck
            && eCourtRecordCheck.isResidentialAddressCheck.maxYears
          )
        );
      }
    }
  }

  setMiscPre() {
    this.showGapDetails = true;
    this.showUANDetails = this.caseConfig.uanCheck && this.caseConfig.uanCheck.selected;
  }

  setPreConditions() {
    this.setEmploymentPre();
    this.setAddressPre();
    this.setMiscPre();
    this.showIdentity = this.caseConfig.identity.selected;
    this.showEducationTab = this.caseConfig.education.selected;

    if (this.showEducationTab) {
      this.maxEducation = this.caseConfig.education.maxEducations;
      this.currTabs.push('educationDetails');
    }

    if (
      (this.caseConfig.creditScoreCheck
      && this.caseConfig.creditScoreCheck.selected)
      || (this.caseConfig.globalDatabaseCheck
      && this.caseConfig.globalDatabaseCheck.selected)
      || (this.caseConfig.indianDatabaseCheck
      && this.caseConfig.indianDatabaseCheck.selected)
      || (this.caseConfig.criminalPoliceCheck
      && this.caseConfig.criminalPoliceCheck.selected)
      || (this.caseConfig.criminalCourtRecordCheck
      && this.caseConfig.criminalCourtRecordCheck.selected)
      || (this.caseConfig.eCourtRecordCheck
      && this.caseConfig.eCourtRecordCheck.selected)
    ) {
      this.isPanAadharRequired = true;
    }

    this.currTabs.push('miscDetails');
  }

  addSection(section) {
    if (section === 'employment') {
      if (this.maxEmployment > this.data.employmentDetails.length) {
        this.data.employmentDetails.push({
          name: '',
          employeeId: '',
          contactNumber: '',
          jobTitle: '',
          dateOfJoining: null,
          dateOfLeaving: null,
          grossSalary: '',
          reasonForLeaving: '',
          supervisorName: '',
          supervisorContactNumber: '',
          hrName: '',
          hrContactNumber: '',
        });
      }
    }

    if (section === 'education') {
      if (this.maxEducation > this.data.educationDetails.length) {
        this.data.educationDetails.push({
          name: '',
          startDate: '',
          endDate: '',
          rollNumber: '',
          instituteDetails: '',
          universityDetails: '',
          instituteContactNumber: '',
        });
      }
    }
  }

  addAddress(type) {
    if (type === 'residential') {
      this.data.addressDetails.residential.push({
        startDate: null,
        endDate: null,
        address: '',
      });
    }

    if (type === 'employment') {
      this.data.addressDetails.employment.push({
        address: '',
      });
    }
  }

  addGap() {
    this.data.miscDetails.gapDetails.push({
      startDate: null,
      endDate: null,
      clarification: '',
    });
  }

  modifyBasicDetailsAttach() {
    this.data.basicDetails.attachments = [];
    Object.entries(this.identity)
      .forEach(([key, value]) => {
        if (value && Object.keys(value).length) {
          const attachments = angular.isArray(value) ? value : [value];
          this.data.basicDetails.attachments = this.data.basicDetails.attachments.concat(
            attachments.map(v => ({
              type: key,
              file: v,
            }))
          );
        }
      });
  }

  identityAttachments(form) {
    if (form.$invalid) return;

    this.modifyBasicDetailsAttach();

    this.stepNext(0, 'basicDetails');
  }

  modifyEducationAttach() {
    this.data.educationDetails
      .forEach((v, i) => {
        if (this.educationAttch[i]) {
          Object.assign(v, {
            attachments: this.educationAttch[i].map(file => ({
              file,
              type: 'Degree',
            })),
          });
        }
      });
  }

  modifyMiscellaneousAttach() {
    this.data.miscDetails.attachments = [];
    Object.entries(this.miscellaneousAttch)
      .forEach(([key, value]) => {
        if (value && Object.keys(value).length) {
          const attachments = angular.isArray(value) ? value : [value];
          this.data.miscDetails.attachments = this.data.miscDetails.attachments.concat(
            attachments.map(v => ({
              type: key,
              file: v,
            }))
          );
        }
      });
  }

  educationAttachments(form) {
    if (form.$invalid) return;

    this.modifyEducationAttach();

    this.stepNext(4, 'educationDetails');
  }

  miscDetails(form) {
    if (form.$invalid) return;

    this.modifyMiscellaneousAttach();

    this.stepNext(0, 'miscDetails');
  }

  modifyEmploymentAttach() {
    this.data.employmentDetails
      .forEach((v, i) => {
        if (this.employmentAttch[i]) {
          Object.assign(v, {
            attachments: this.employmentAttch[i].map(file => ({
              file,
              type: 'Employment',
            })),
          });
        }
      });
  }

  employmentAttachments(form) {
    if (form.$invalid) return;

    this.modifyEmploymentAttach();

    this.stepNext(1, 'employmentDetails');
  }

  indexValue(tabName) {
    return this.currTabs.findIndex(v => v === tabName) + 1;
  }

  cleanData() {
    if (this.data.miscDetails && this.data.miscDetails.gapDetails) {
      this.data.miscDetails.gapDetails = this.data.miscDetails.gapDetails.map(gap => ({
        startDate: gap.startDate,
        endDate: gap.endDate,
        clarification: gap.clarification,
      }));
    }
  }

  submit() {
    let formInvalid = false;
    const messageList = [
      'You have successfully filled the Candidate Information Form.',
      'Please check your email and share a signed Authorization to proceed with the BGV.',
    ].join(' \n ');

    this.forms.forEach(v => {
      if (v) {
        Object.assign(v, { $dirty: true });
        if (v.$invalid) formInvalid = true;
      }
    });

    if (this.submitting || formInvalid) return;

    const url = this.ignoreAuth
      ? `/public/case/${this.caseConfigId}/response`
      : `/case/${this.caseConfigId}/response`;

    this.submitting = true;
    this.showSpinner = true;

    this.cleanData();
    this.$http.post(url, this.data, {
      ignoreAuthModule: this.ignoreAuth,
    })
      .then(() => {
        this.submitting = false;

        if (this.ignoreAuth) {
          this.$state.go('thank-you', {
            msg: messageList,
          });
        } else {
          this.$state.go('main.cases.view', { id: this.caseConfigId });
        }

        this.Session.remove(`case_${this.caseConfigId}`);
      })
      .catch(() => {
        this.submitting = false;
        this.showSpinner = false;
      });
  }

  saveToLocalStorage() {
    this.Session.create(`case_${this.caseConfigId}`, angular.toJson(this.data));
  }

  stepNext(currentStep, currTabName, form) {
    if (form && form.$invalid) return true;

    const nextTabName = this.currTabs[this.currTabs.findIndex(v => v === currTabName) + 1];
    const nextTabIndex = this.tabIndexMap[nextTabName];

    if (!nextTabName) return this.submit();

    this.steps[nextTabIndex] = true;
    this.activeTab = nextTabIndex;
    this.$window.scrollTo(0, 0);

    this.saveToLocalStorage();

    return true;
  }

  tabPillClass(currentStep) {
    const className = ['b-a b-3x'];
    const form = this.forms[currentStep];

    if (this.activeTab === currentStep) className.push('bg-info font-bold');
    if (form) {
      if (form.$submitted && !form.$invalid) {
        className.push('b-success');
      }

      if (form.$dirty && form.$invalid) className.push('b-danger');

      return className.join(' ');
    }

    return '';
  }

  removeSection(section, index, attachment, optional = false) {
    if (section.length === 1 && !optional) return;

    section.splice(index, 1);

    if (attachment) this[attachment].splice(index, 1);
  }
}

export default FillController;



// WEBPACK FOOTER //
// ./client/app/cases/fill/fill.controller.js